<ion-header class="ion-hide-lg-up" mode="ios">
  <header-main></header-main>
</ion-header>

<ion-content fullscreen #content class="p">
  <header class="ion-header ion-hide-lg-up">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-icon size="large" src="assets/icons/promote.svg" color="white" class="ion-margin"></ion-icon>
      </ion-buttons>
      <ion-title class="ion-no-padding">Promote <small>- business & freelance ads</small></ion-title>
    </ion-toolbar>
  </header>
  <header class="ion-hide-lg-down">
    <header-desktop></header-desktop>
    <h1 color="white"><ion-icon src="assets/icons/promote.svg" color="white"></ion-icon>Promote <small>- business & freelance ads</small></h1>
  </header>
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col [ngClass]="filterby ? 'active' : 'ion-hide'" class="filter ion-no-padding" size="12" size-lg="3" size-xl="2">
        <ion-icon class="filter-icon" color="white" size="large" src="assets/icons/filter.svg" (click)="filterby = !filterby"></ion-icon>
        <search-classifications (searchOutput)="getFilters($event)" (clearOutput)="clearFilters($event)"></search-classifications>
      </ion-col>
      <ion-col class="ion-no-padding">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col class="search ion-padding-start" size="12" size-lg="12">
              <ion-icon class="filter-icon" [ngClass]="!filterby ? 'active' : 'ion-hide'" color="white" size="large" src="assets/icons/filter.svg" (click)="filterby = !filterby"></ion-icon>
              <ion-searchbar debounce="500" (ionChange)="getSearch($event)" type="search" [value]="searchValue" placeholder="Enter Keywords" class="ion-no-padding"></ion-searchbar>
            </ion-col>
            <!-- <ion-col class="sort ion-padding" size="12" size-lg="3">
              <ion-label color="secondary">Sort By</ion-label>
              <ion-icon color="secondary" size="small" src="assets/icons/dropdown.svg"></ion-icon>
            </ion-col> -->
          </ion-row>
          <ion-row>
            <ion-col class="feed" role="feed" size="12" size-md="10" size-lg="8" size-xl="6" offset-md="1" offset-xl="2">
              <ng-container *ngIf="!loading && !dataList.length;">
                <ion-card>
                  <ion-card-header>
                    <ion-fab horizontal="end">
                      <ion-fab-button color="light" size="small">
                        <ion-icon color="secondary" size="small" src="assets/icons/ge.svg"></ion-icon>
                      </ion-fab-button>
                    </ion-fab>
                    <ion-card-title>
                      No
                      <span *ngIf="filtersObj.group && !filtersObj.class">{{filtersObj.group}}</span>
                      <span *ngIf="filtersObj.group && filtersObj.class">{{filtersObj.class}}</span>
                      Ads here
                    </ion-card-title>
                  </ion-card-header>
                  <ion-card-content class="ion-padding-top">
                    <ion-card-subtitle>
                      <span class="date ion-padding-end">
                        <ion-icon src="assets/icons/time.svg" color="secondary" size="small"></ion-icon>
                        {{today | date: 'd MMM' }}
                      </span>
                      <span *ngIf="filtersObj.location != 'remote'" class="location ion-padding-end">
                        <ion-icon *ngIf="filtersObj.country" src="assets/flags/{{filtersObj.country | lowercase}}.svg" color="secondary" size="small"></ion-icon>
                        <ion-icon *ngIf="!filtersObj.country" src="assets/icons/globe.svg" color="secondary" size="small"></ion-icon>
                        <span *ngIf="!filtersObj.name && !filtersObj.region">Onsite</span>
                        <span *ngIf="filtersObj.name && !filtersObj.region">{{filtersObj.name}}</span>
                        <span *ngIf="filtersObj.name && filtersObj.region">{{filtersObj.region}}, {{filtersObj.name}}</span>
                      </span>
                      <span *ngIf="filtersObj.location == 'remote'" class="location ion-padding-end">
                        <ion-icon src="assets/icons/globe.svg" color="secondary" size="small"></ion-icon>
                        <span>Remote</span>
                      </span>
                    </ion-card-subtitle>
                    <p class="ion-padding">
                      Refine your search and location to find
                      <span *ngIf="filtersObj.group && !filtersObj.class">{{filtersObj.group}}</span>
                      <span *ngIf="filtersObj.group && filtersObj.class">{{filtersObj.class}}</span>
                      Ads that you need
                    </p>
                    <ion-button *ngIf="!filterby" (click)="filterby = !filterby" color="tertiary" shape="round">Filter By</ion-button>
                  </ion-card-content>
                </ion-card>
                <ion-card>
                  <ion-card-header>
                    <ion-fab horizontal="end">
                      <ion-fab-button color="light" size="small">
                        <ion-icon color="secondary" size="small" src="assets/icons/ge.svg"></ion-icon>
                      </ion-fab-button>
                    </ion-fab>
                    <ion-card-title>
                      Waiting for
                      <span *ngIf="filtersObj.group && !filtersObj.class">{{filtersObj.group}}</span>
                      <span *ngIf="filtersObj.group && filtersObj.class">{{filtersObj.class}}</span>
                      Ads
                    </ion-card-title>
                  </ion-card-header>
                  <ion-card-content class="ion-padding-top">
                    <ion-card-subtitle>
                      <span class="date ion-padding-end">
                        <ion-icon src="assets/icons/time.svg" color="secondary" size="small"></ion-icon>
                        {{today | date: 'd MMM' }}
                      </span>
                      <span *ngIf="filtersObj.location != 'remote'" class="location ion-padding-end">
                        <ion-icon *ngIf="filtersObj.country" src="assets/flags/{{filtersObj.country | lowercase}}.svg" color="secondary" size="small"></ion-icon>
                        <ion-icon *ngIf="!filtersObj.country" src="assets/icons/globe.svg" color="secondary" size="small"></ion-icon>
                        <span *ngIf="!filtersObj.name && !filtersObj.region">Onsite</span>
                        <span *ngIf="filtersObj.name && !filtersObj.region">{{filtersObj.name}}</span>
                        <span *ngIf="filtersObj.name && filtersObj.region">{{filtersObj.region}}, {{filtersObj.name}}</span>
                      </span>
                      <span *ngIf="filtersObj.location == 'remote'" class="location ion-padding-end">
                        <ion-icon src="assets/icons/globe.svg" color="secondary" size="small"></ion-icon>
                        <span>Remote</span>
                      </span>
                    </ion-card-subtitle>
                    <p class="ion-padding">
                      Place your 
                      <span *ngIf="filtersObj.group && !filtersObj.class">{{filtersObj.group}}</span>
                      <span *ngIf="filtersObj.group && filtersObj.class">{{filtersObj.class}}</span>
                      Promote Ad here and reach millions of our customers
                      <span *ngIf="filtersObj.name && !filtersObj.region">in {{filtersObj.name}} and beyond</span>
                      <span *ngIf="filtersObj.name && filtersObj.region">in {{filtersObj.region}}, {{filtersObj.name}} and beyond</span>
                    </p>
                    <ion-button color="tertiary" [routerLink]="'/account/promote/'" shape="round">Get Started</ion-button>
                  </ion-card-content>
                </ion-card>
              </ng-container>
              <ng-container *ngIf="!loading && dataList.length">
                <ad-card *ngFor="let ad of dataList" [id]="ad.id" (click)="adDetail(ad.id,ad.slug)"></ad-card>
                <ion-infinite-scroll threshold="100px" (ionInfinite)="loadData($event)">
                  <ion-infinite-scroll-content loadingSpinner="dots" loadingText=""><ng-container *ngIf="dataList.length > 5"><small>scroll down for more</small><small class="chevron-down">^</small></ng-container></ion-infinite-scroll-content>
                </ion-infinite-scroll>
              </ng-container>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</ion-content>

<ion-footer class="ion-hide-lg-up">
  <footer-main></footer-main>
</ion-footer>
